var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,0,255)",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20 L20 80 L30 80 L30 50 L50 80 L60 80 L40 50 L60 20 L50 20 L30 40 L30 20 Z",
    fill: "url(#grad1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    from: "M20 20 L20 80 L30 80 L30 50 L50 80 L60 80 L40 50 L60 20 L50 20 L30 40 L30 20 Z",
    to: "M20 20 L20 80 L30 80 L30 50 L70 80 L80 80 L50 50 L80 20 L70 20 L40 40 L40 20 Z",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 20 L70 80 L80 80 L80 20 Z",
    fill: "url(#grad1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b80a013d8d4d15aad70c7f0b2a5f3b09.svg";
export { ForwardRef as ReactComponent };